import { render } from "./TaskModal.vue?vue&type=template&id=3446cdd4&scoped=true"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import "./TaskModal.vue?vue&type=style&index=0&id=3446cdd4&lang=css"
import "./TaskModal.vue?vue&type=style&index=1&id=3446cdd4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3446cdd4"]])

export default __exports__